import script from "./ExpireOverdueConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpireOverdueConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./ExpireOverdueConfirmModal.vue?vue&type=style&index=0&id=3aeb3854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aeb3854"]])

export default __exports__